import React, { Component } from 'react';
import moment from 'moment-timezone';
import classNames from 'classnames';
import { ParticipantVirtualGraduationState } from 'stageclip-common';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import Button from 'components/buttons/button';
import AppModal from 'components/modal/appModal';
import { DeleteAssetModal } from './deleteAssetModal/DeleteAssetModal';
import styles from './ReviewModal.module.scss';
import { Asset, ReviewModalContentProps } from './ReviewModal.types';

const deadlineWarningMaxDiff = moment.duration(24, 'h').asMilliseconds();

export class ReviewModalContent extends Component<ReviewModalContentProps> {
  renderWarning = () => {
    const { eventDeadlineDate } = this.props;

    if (!eventDeadlineDate) {
      return null;
    }

    const diff = moment(eventDeadlineDate).diff(moment());

    if (diff <= 0) {
      return <div className={classNames(styles.infoBox, styles.infoBoxDanger)}>It&apos;s past the deadline</div>;
    }

    if (diff <= deadlineWarningMaxDiff) {
      return (
        <div className={classNames(styles.infoBox, styles.infoBoxWarning)}>
          {`There's only ${moment.duration(diff).humanize()} until deadline is reached`}
        </div>
      );
    }

    return null;
  };

  handleApprove = () => {
    const {
      data: {
        participant: { id },
      },
      updateParticipantVGState,
    } = this.props;

    updateParticipantVGState(id, ParticipantVirtualGraduationState.Accepted);
  };

  handleReject = () => {
    const {
      updateParticipantVGState,
      data: {
        participant: { id },
      },
    } = this.props;

    updateParticipantVGState(id, ParticipantVirtualGraduationState.Rejected);
  };

  handleDeleteModalOpen = (asset: Asset) => () => {
    const {
      data: {
        participant: { id },
      },
      openDeleteModal,
    } = this.props;

    openDeleteModal({ asset, participantId: id });
  };

  render() {
    const {
      id,
      participant: { virtualGraduation },
    } = this.props;
    const hideApprovalButton = virtualGraduation.state !== ParticipantVirtualGraduationState.Submitted;
    const hideActionButtons = ![
      ParticipantVirtualGraduationState.Submitted,
      ParticipantVirtualGraduationState.Accepted,
    ].includes(virtualGraduation.state);
    const warning = this.renderWarning();

    return (
      <>
        <AppModal
          id={id}
          title="Review"
          hideOpenButton
          submitButtonLabel="Approve"
          submitAction={hideApprovalButton ? null : this.handleApprove}
          closeButtonLabel="Reject"
          onClose={this.handleReject}
          hideActionButtons={hideActionButtons}
          className="review-modal"
        >
          {warning}
          <section className={styles.section}>
            <h3>Video:</h3>
            {virtualGraduation.file ? (
              <>
                <video controls src={virtualGraduation.file}>
                  <track default kind="captions" />
                </video>
                <Button
                  className={styles.removeButton}
                  text="Remove video"
                  icon={faTrash}
                  slimButton
                  onClick={this.handleDeleteModalOpen('file')}
                  inverseColours
                />
              </>
            ) : (
              'N/A'
            )}
          </section>

          <section className={styles.section}>
            <h3> Image:</h3>
            {virtualGraduation.image ? (
              <>
                <img src={virtualGraduation.image} alt="Virtual graduation slide" />
                <Button
                  className={styles.removeButton}
                  text="Remove image"
                  icon={faTrash}
                  slimButton
                  onClick={this.handleDeleteModalOpen('image')}
                  inverseColours
                />
              </>
            ) : (
              'N/A'
            )}
          </section>

          <section className={styles.section}>
            <h3>Message:</h3>
            {virtualGraduation.message ? (
              <>
                <div>{virtualGraduation.message}</div>
                <Button
                  className={styles.removeButton}
                  text="Remove message"
                  icon={faTrash}
                  slimButton
                  onClick={this.handleDeleteModalOpen('message')}
                  inverseColours
                />
              </>
            ) : (
              'N/A'
            )}
          </section>
        </AppModal>
        <DeleteAssetModal />
      </>
    );
  }
}
